
  import { mapState } from 'vuex'
  export default {
    name: 'Theme2MissionMobileRewardHistoryCard',
    props: {
      coinLength: {
        type: Number,
        default: 1
      },
      item: {
        type: Object,
        default: () => {}
      },
      cardIndex: {
        type: Number,
        default: 0
      },
      displayFullText: {
        type: Boolean,
        default: false
      },
      bgClass: {
        type: String,
        default: 'w-blacktransparent-opacity'
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        missionsSettings: state => state.activities['mission-reward'].missionsSettings
      })
    },
    methods: {
      getStatusLabel(status) {
        switch (status) {
          case 1:
            return this.tl('pending')
          case 2:
            return this.tl('success')
          case 3:
            return this.tl('rejected')
          default:
            return '-'
        }
      },
      getStatusColor(status) {
        switch (status) {
          case 1:
            return 'primary'
          case 2:
            return 'success'
          case 3:
            return 'error'
          default:
            return 'grey'
        }
      },
      onCardClick() {
        this.$emit('click')
      }
    }
  }
